import { render, staticRenderFns } from "./OneGroup.vue?vue&type=template&id=1d2c0450&scoped=true"
import script from "./OneGroup.vue?vue&type=script&lang=js"
export * from "./OneGroup.vue?vue&type=script&lang=js"
import style0 from "./OneGroup.vue?vue&type=style&index=0&id=1d2c0450&prod&lang=scss&scoped=true"
import style1 from "./OneGroup.vue?vue&type=style&index=1&id=1d2c0450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c0450",
  null
  
)

export default component.exports